@for (point of routePoints().points; track trackPoint(point)) {
  @if (isVisible(point, $first, $last)) {
    <app-route-point
      [style.z-index]="routePoints().points.length - $index"
      [point]="point"
      [currentEndingDelegations]="currentEndingDelegations()"
      [hideOptions]="hidePointOptions()"
    ></app-route-point>
  }
}

@if (showDelegationCycle()) {
  @if (
    routePoints().endCycleDelegationPoints.length ||
    incompleteEndCycleDelegationPoints().length
  ) {
    <div class="breaker">
      <div class="no-more-orders">
        @if (!hasActiveCycle()) {
          <div class="icon">
            <onyx-icon
              class="f-danger"
              name="vehicle-free-dotted-outlined"
              [size]="16"
            ></onyx-icon>
          </div>
        } @else {
          <onyx-icon class="f-muted" name="good-filled" [size]="16"></onyx-icon>
        }

        <span class="f-body-s">
          <span class="{{ hasActiveCycle() ? 'f-muted' : 'f-danger' }}">
            {{ `${I18N}.details.delegation.noMoreOrders` | translate }}
          </span>

          @if (!hasActiveCycle()) {
            <span>·&nbsp;</span>

            <onyx-link color="blue" font="f-body-s" (click)="openActionModal()">
              {{ 'labels.beginReturn' | translate }}
            </onyx-link>
          }
        </span>
      </div>
    </div>
  }

  @for (
    point of routePoints().endCycleDelegationPoints;
    track trackPoint(point)
  ) {
    <app-route-point
      [point]="point"
      variant="preview"
      previewColor="transparent"
      [forceIcons]="true"
      [interactivePreview]="true"
    ></app-route-point>
  }

  @for (
    delegation of incompleteEndCycleDelegationPoints();
    track delegation.uuid
  ) {
    @let end = delegation.end;
    <div class="point">
      <app-route-point-marker
        [size]="32"
        icon="delegation-filled"
        [isDelegation]="true"
      ></app-route-point-marker>

      <div class="content">
        @if (end.address; as address) {
          <onyx-address
            class="f-body-m f-semibold"
            [address]="address"
            format="city-flag"
          ></onyx-address>
        } @else {
          <onyx-link
            color="blue"
            font="f-body-m f-semibold"
            (click)="editDelegation(delegation.uuid)"
          >
            {{ 'labels.setEndAddress' | translate }}
          </onyx-link>
        }

        <span class="f-muted f-body-xs">
          {{
            `${I18N}.details.delegation.${getDelegationLabel($index)}`
              | translate
          }}
        </span>
      </div>

      <span>
        @if (end.date || end.time) {
          <span class="f-muted">{{ 'labels.term' | translate }}&nbsp;</span>

          @if (end.time; as time) {
            <span>
              {{ time | onyxTime }}
            </span>
          } @else {
            <onyx-link
              color="blue"
              font="f-body-s f-medium"
              (click)="editDelegation(delegation.uuid)"
            >
              {{ 'labels.setEndTime' | translate }}
            </onyx-link>
          }

          <span>·</span>

          @if (end.date; as date) {
            <span class="f-muted">
              {{ date | onyxDate: 'date-dot' }}
            </span>
          } @else {
            <onyx-link
              color="blue"
              font="f-body-s f-medium"
              (click)="editDelegation(delegation.uuid)"
            >
              {{ 'labels.setEndDate' | translate }}
            </onyx-link>
          }
        } @else {
          <onyx-link
            color="blue"
            font="f-body-s f-semibold"
            (click)="editDelegation(delegation.uuid)"
          >
            {{ 'labels.setEndDate' | translate }}
          </onyx-link>
        }
      </span>
    </div>
  }
}
